import Link from 'next/link';
import React from 'react';
import { isVirtualChannel } from '../../../../common/utils/liveUtil';

export default function AllVodButton(props) {
  const { vod_url, channelid } = props.info;
  const url = vod_url;
  const linkUrl = url && isVirtualChannel(channelid) ? `${url}${url.includes('?') ? '&' : '?'}ref=24tv` : url;
  
  return (<>
    {linkUrl && (<div className='live_btn_allvod'>
      <Link href={linkUrl}>
        <a className="live_link_cont" target="_blank" title="allvod">
          <span className="live_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="27.598" height="26.247" viewBox="0 0 27.598 26.247">
              <g className="icon_allvod" transform="translate(0.34 -0.002)">
                <path id="패스_6903" data-name="패스 6903" d="M19916.762-4857.144a5.8,5.8,0,0,1,1.281-3.893,4.3,4.3,0,0,1,3.338-1.441,4.3,4.3,0,0,1,3.332,1.441,5.79,5.79,0,0,1,1.285,3.9c0,3.222-1.855,5.388-4.617,5.388S19916.762-4853.917,19916.762-4857.144Zm1.826,0c0,2.311,1.1,3.8,2.793,3.8s2.791-1.491,2.791-3.8-1.07-3.748-2.791-3.748S19918.588-4859.456,19918.588-4857.144Zm9.111,5.218V-4862.3h2.822a5.038,5.038,0,0,1,3.768,1.356,5.244,5.244,0,0,1,1.311,3.8c0,3.317-1.832,5.218-5.023,5.218Zm1.8-1.521h.91c2.768,0,3.348-2.006,3.348-3.692,0-2.417-1.131-3.643-3.352-3.643h-.906Zm-18.066,1.521-.064-.17L19908-4862.3h1.881l.055.175,1.662,5.358c.154.48.285.936.41,1.371.119.41.234.811.369,1.23.121-.4.236-.785.346-1.186.141-.45.275-.916.436-1.416l1.7-5.534h1.836l-.105.325-3.307,10.052Zm20.664-12.528V-4878h3.246v13.543Zm-5.4,0V-4878h3.246v13.543Zm-18.357,0,8.115-13.539,8.109,13.539Z" transform="translate(-19908.342 4878)" />
              </g>
            </svg>
            <i className="hide">allvod</i>
          </span>
          <div className="live_allvodText_w">
            <span className="live_allvod_text">{props.info.free ? '무료보기' : '다시보기'}</span>
          </div>
        </a>
      </Link>
    </div>)}
  </>
  );
}
